import React, { Component } from "react";
import { Button, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledAlert } from "reactstrap";
import AdminDashBoardTable from "./AdminDashBoardTable";
import AdminDataBoardForm from "./AdminDataBoardForm";
import { adminDashBoardService } from "./services/adminDashBoard.service";
import { MdAdd } from "react-icons/md";
import { TextInput } from "../../Shared/Forms/TextInput";
import Formsy from "formsy-react";
import { Spinner } from "../../Shared";
import { toast } from "react-toastify";
import WelcomeScreen from "../../../_utils/WelcomeScreen";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";

import { tourMessages } from "../../../_constants/tutorialmessages/ManualMessages";

class ManageAdminDashBoard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fetching: false,
            submitting: false,
            formError: null,
            data: null,
            selectedRow: null,
            hasParams: false,
            error: null,
            submitSucessful: false,
            pageNum: 0,
            pageSize: 10,
            showModal: false,
            notResetMode: false,
            status: "PENDING",
            totalDrafts: 0,
            totalPending: 0,
            totalApproved: 0,
            totalDeclined: 0,
            total: 0,
            isUploadFrequencyClick: false,
            canSubmit: false,
            postFrequency: 0,
            postCycle: "Daily",
            isFirstTimeUser: !!localStorage.getItem("visited") || false,
            run: false,
            stepIndex: 0,
            steps: [
                {
                    target: tourMessages.adminDash.target,
                    tooltipOffset: 1000,
                    style: {
                        main: { top: "10rem" },
                    },
                    content: (
                        <div>
                            <p>{tourMessages.adminDash.content}</p>
                        </div>
                    ),
                    placement: "left",
                    locale: { skip: "SKIP", close: "Next" },
                },
                tourMessages.default,
            ],

            showNextJoyRide: false,
        };
    }
    componentDidMount() {
        const { pageNum, pageSize, status } = this.state;
        this.getAllPendingPosts({
            status,
            pageNum: pageNum + 1,
            pageSize,
        });
        this.getPostCycle();
        this.getAllData();
        if (this.state.isFirstTimeUser) {
            this.setState({ isFirstTimeUser: false });
        } else {
            localStorage.setItem("visited", true);
            this.setState({ isFirstTimeUser: true });
        }
    }

    //=======================TABLE/FORM MANAGEMENT SECTION===============================
    getPostCycle = () => {
        adminDashBoardService
            .showPostCycle()
            .then((response) => {
                if (response.numberOfDays === "7") {
                    this.setState({
                        postFrequency: response.numberOfPosts,
                        postCycle: "Weekly",
                        showModal: false,
                    });
                } else if (response.numberOfDays === "30") {
                    this.setState({
                        postFrequency: response.numberOfPosts,
                        postCycle: "Monthly",
                        showModal: false,
                    });
                } else {
                    this.setState({
                        postFrequency: response.numberOfPosts,
                        postCycle: "Daily",
                        showModal: false,
                    });
                }
            })
            .catch((error) => this.setState({ error, fetching: false }));
    };
    setPostFrequency = (data) => {
        this.setState({
            submitting: true,
            formError: null,
            submitSucessful: false,
        });

        adminDashBoardService
            .setPostFrequency(data)
            .then((response) => {
                this.setState({
                    response,
                    formError: null,
                    submitting: false,
                    submitSucessful: true,
                });
                toast.success("Post frequency set successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });
                this.resetPostFrequency();
                this.getPostCycle();
            })
            .catch((error) => {
                this.setState({ formError: error, submitting: false });
            });
    };
    getAllData = () => {
        adminDashBoardService
            .getAllDashBoardData()
            .then((response) => {
                response &&
                    this.setState({
                        totalPending: response.totalPending,
                        totalApproved: response.totalApproved,
                        totalDeclined: response.totalDeclined,
                        total: response.total,
                    });
            })
            .catch((error) => this.setState({ error, fetching: false }));
    };
    getAllPendingPosts = (params) => {
        this.setState({ fetching: true });
        adminDashBoardService
            .getAllPendingPost(params)
            .then((response) => {
                response &&
                    this.setState({
                        data: response,
                        pages: Math.ceil(response.count / params.pageSize),
                        error: null,
                        fetching: false,
                    });
            })
            .catch((error) => this.setState({ error, fetching: false }));
    };

    selectRow = (selectedRow) => {
        this.setState({ selectedRow: selectedRow.original, hasParams: true });
    };

    showConfirmation = (selectedRow) => {
        this.setState({
            selectedRow: selectedRow.original,
            showModal: !this.state.showModal,
        });
    };

    fetchData = () => {
        const { pageNum, pageSize, status, filterParams } = this.state;
        let params = { status, pageNum: pageNum + 1, pageSize };
        if (filterParams) {
            params = { ...filterParams, ...params };
        }
        this.getAllPendingPosts(params);
    };

    setPageNumber = (pageIndex) => {
        this.setState({ pageNum: pageIndex }, () => this.fetchData());
    };

    setPageSize = (pageSize, pageIndex) => {
        this.setState({ pageSize, pageNum: pageIndex }, () => this.fetchData());
    };

    filterData = (params) => {
        const filterParams = {
            ...this.state.filterParams,
            ...params,
        };

        this.setState({ filterParams, pageNum: 0 }, () => this.fetchData());
    };

    disableButton = () => {
        this.setState({ canSubmit: false });
    };

    enableButton = () => {
        this.setState({ canSubmit: true });
    };

    resetPostFrequency = () => {
        this.refs.setPostFrequencyForm.reset();
    };

    handleSubmit = (data) => {
        let numDays = data.numDays;
        if (data.numDays == null) {
            numDays = 1;
        }
        let request = [
            {
                settingKey: "Number_Of_Posts",
                settingValue: data.postsNum,
            },
            {
                settingKey: "Number_Of_Days",
                settingValue: numDays,
            },
        ];

        this.setPostFrequency(request);
    };
    //=======================TOUR GUIDE SECTION===============================
    skipTutorialGuide = () => {
        this.setState({ isFirstTimeUser: false });
    };

    startTutorialGuide = () => {
        this.setState({ isFirstTimeUser: false, run: true });
    };

    handleJoyrideCallback = (data) => {
        const { action, index, status, type } = data;

        if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
            this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
        } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
            if ([STATUS.SKIPPED].includes(status)) {
                this.setState({ run: false });
            } else {
                this.setState({ run: false, showNextJoyRide: true });
            }
        }
    };

    setNextJoyRide = () => {
        this.setState({ showNextJoyRide: false });
    };
    routeChange = () => {
        this.props.history.push({
            pathname: `/verifiedcontents`,

            state: { run: true },
        });
    };
    render() {
        const { fetching, data, pages, pageNum, pageSize, error, filterParams, submitting, canSubmit, formError, hasParams, selectedRow, totalApproved, totalDeclined, total, postCycle, postFrequency, isFirstTimeUser, run, steps, stepIndex, showNextJoyRide } = this.state;
        return (
            <div>
                {/* <Joyride
                    steps={steps}
                    scrollToFirstStep
                    showProgress
                    showSkipButton
                    styles={{
                        options: {
                            width: 200,
                            height: 30,
                            zIndex: 1000
                        }
                    }}
                    callback={this.handleJoyrideCallback}
                    run={run}
                    stepIndex={stepIndex}
                /> */}

                <div>
                    {/* {isFirstTimeUser && <WelcomeScreen isFirstTimeUser={isFirstTimeUser} skipTutorialGuide={this.skipTutorialGuide} startTutorialGuide={this.startTutorialGuide} />} */}
                    <Button type="button" color="primary" className="mb-2 joyride1" onClick={this.showConfirmation}>
                        <MdAdd />
                        Set Upload Frequency
                    </Button>

                    <Modal isOpen={this.state.showModal} toggle={this.showConfirmation}>
                        <ModalHeader toggle={this.showConfirmation}>Set Upload Frequency</ModalHeader>
                        <Formsy ref="setPostFrequencyForm" onValidSubmit={this.handleSubmit} onValid={this.enableButton} onInvalid={this.disableButton} noValidate>
                            <ModalBody>
                                {formError ? <UncontrolledAlert color="danger">{formError.message}</UncontrolledAlert> : null}

                                <TextInput
                                    name="postsNum"
                                    value={selectedRow && hasParams ? selectedRow.name : null}
                                    required
                                    disabled={submitting}
                                    title="Number of Uploads"
                                    validations={{
                                        isNumeric: true,
                                    }}
                                    validationErrors={{
                                        isNumeric: "Enter number only",
                                    }}
                                />

                                <TextInput name="numDays" type="select" value={selectedRow && hasParams ? selectedRow.name : null} title="Duration" isSelectDropDown={true} />
                            </ModalBody>
                            <ModalFooter>
                                <Button color="primary" type="submit" disabled={!canSubmit || submitting}>
                                    {" "}
                                    {submitting ? <Spinner size="sm" /> : <span>Save</span>}
                                </Button>{" "}
                                <Button color="secondary" onClick={this.showConfirmation}>
                                    Close
                                </Button>
                            </ModalFooter>
                        </Formsy>
                    </Modal>
                </div>

                <Row>
                    <Col sm="12">
                        <div style={{ marginBottom: "3rem" }}>
                            <AdminDataBoardForm error={error} totalApproved={totalApproved} totalDeclined={totalDeclined} total={total} postFrequency={postFrequency} postCycle={postCycle} />
                        </div>

                        <AdminDashBoardTable
                            fetching={fetching}
                            hasParams={hasParams}
                            selectedRow={selectedRow}
                            data={data}
                            selectRow={this.selectRow}
                            error={error}
                            pages={pages}
                            page={pageNum}
                            pageSize={pageSize}
                            filterData={this.filterData}
                            setPageNumber={this.setPageNumber}
                            setPageSize={this.setPageSize}
                            postId={selectedRow}
                            filterParams={filterParams}
                            showNextJoyRide={showNextJoyRide}
                            setNextJoyRide={this.setNextJoyRide}
                            routeChange={this.routeChange}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default ManageAdminDashBoard;
